import apiClient from './apiClient';
import createCrudApi from './createCrudApi';

const promosClient = apiClient('');
const promosApi = createCrudApi(promosClient, 'promos');


// 🔹 Получение по пагинации с фильтрацией
promosApi.getPaginatedPromos = async ({ page = 1, limit = 20, status, promoType }) => {
    const response = await promosClient.get('/promos/paginated', {
        params: {
            page,
            limit,
            status,
            promoType,
        },
    });
    return response.data;
};
// 🔍 Поиск по токену, имени или ссылке промоутера
promosApi.searchPromos = async (query) => {
    const response = await promosClient.get('/promos/search', {
        params: { q: query },
    });
    return response.data;
};

// Дополнительные методы
promosApi.syncTelegramMeta = async (link) => {
    const response = await promosClient.get('/promos/sync-meta', {
        params: { link },
    });
    return response.data;
};

// Если используешь FormData:
promosApi.createWithPromoters = async (promoData) => {
    const formData = new FormData();

    for (const key in promoData) {
        if (key === 'promoters') {
            formData.append(key, JSON.stringify(promoData.promoters));
        } else if (promoData[key] !== undefined && promoData[key] !== null) {
            formData.append(key, promoData[key]);
        }
    }

    const response = await promosClient.post('/promos', formData);
    return response.data;
};


promosApi.updateWithPromoters = async (id, promoData) => {
    const formData = new FormData();

    for (const key in promoData) {
        if (key === 'promoters') {
            formData.append(key, JSON.stringify(promoData.promoters));
        } else if (promoData[key] !== undefined && promoData[key] !== null) {
            formData.append(key, promoData[key]);
        }
    }

    const response = await promosClient.put(`/promos/${id}`, formData);
    return response.data;
};

const userPromos = {
    async startPromo(id){
        const response = await promosClient.post(`/promos/start/${id}`);
        return response.data
    },
    async getPromos(id) {
        const response = await promosClient.get(`user-promos/${id}`);
        return response.data;
    },

    async subPromo(userID, promoID) {
        const response = await promosClient.post(`/user-promos/${userID}/${promoID}`, {});
        return response.data;
    },

    async unSubPromo(userID, promoID) {
        const response = await promosClient.delete(`/user-promos/${userID}/${promoID}`);
        return response.data;
    },
};

export default { promosApi, userPromos };
